import { RoleGate } from "@/common/components/layout/RoleGate";
import { Plus } from "lucide-react";

type Props = {
  count: number | null;
  onCreate: () => void;
};

export function CostAllocationsListHeader({ count, onCreate }: Props) {
  return (
    <header className="flex flex-col gap-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h1 className="font-medium text-3xl text-app-ink-1 tracking-tight">Costos</h1>
          {count !== null && (
            <p className="mt-1 text-app-ink-3 text-sm">
              {count} {count === 1 ? "costo" : "costos"}
            </p>
          )}
        </div>

        <RoleGate roles={["owner", "admin"]}>
          <button
            type="button"
            onClick={onCreate}
            data-testid="costs-create-button"
            className="inline-flex items-center gap-2 rounded-2xl bg-app-ink-1 px-4 py-2.5 font-medium text-[14px] text-white transition-colors hover:bg-[#1e211d]"
          >
            <Plus size={16} strokeWidth={2} />
            <span className="hidden sm:inline">Registrar costo</span>
            <span className="sm:hidden">Registrar</span>
          </button>
        </RoleGate>
      </div>
    </header>
  );
}
